import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@hooks/useTheme";
import { HomeIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";

const UnauthorizedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { colors } = useTheme();

  const handleGoToLogin = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div data-testid="unauthorized-page" className={`min-h-full flex items-center justify-center ${colors.bgSecondary}`}>
      <div className={`max-w-md w-full mx-auto text-center border ${colors.bgPrimary} ${colors.borderPrimary} rounded-2xl p-8 shadow-lg`}>
        {/* Unauthorized Icon */}
        <div className="mb-6">
          <div className={`mx-auto w-24 h-24 rounded-full ${colors.bgDanger} flex items-center justify-center`}>
            <span className={`text-4xl font-bold ${colors.textOnPrimary}`}>401</span>
          </div>
        </div>

        {/* Error Message */}
        <h1 className={`text-2xl font-bold mb-4 ${colors.textPrimary}`}>
          {t("unauthorized.title", "Unauthorized Access")}
        </h1>
        
        <p className={`text-base mb-8 ${colors.textSecondary}`}>
          {t("unauthorized.message", "You do not have permission to use the requested page.")}
        </p>

        <p className={`text-base mb-8 ${colors.textSecondary}`}>
          {t("unauthorized.instruction", "To continue working on the requested page, you must log in again with an account with appropriate permissions.")}
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleGoToLogin}
            className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-sm transition-colors ${colors.textButton} ${colors.buttonBackgroundGradient} hover:opacity-90`}
          >
            <HomeIcon className="h-5 w-5" />
            {t("unauthorized.go-login", "Go to Login")}
          </button>
          
          <button
            onClick={handleGoBack}
            className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg border transition-colors ${colors.borderPrimary} ${colors.textSecondary} ${colors.hover}`}
          >
            <ArrowLeftIcon className="h-5 w-5" />
            {t("unauthorized.go-back", "Go Back")}
          </button>
        </div>

        {/* Additional Help */}
        <div className={`mt-8 pt-6 border-t ${colors.borderPrimary}`}>
          <p className={`text-sm ${colors.textSecondary}`}>
            {t("unauthorized.help", "If you believe you should have access to this page, please contact your administrator.")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage; 